import { render, staticRenderFns } from "./CardsObjectivesRules.vue?vue&type=template&id=78e69d50&scoped=true&"
import script from "./CardsObjectivesRules.vue?vue&type=script&lang=js&"
export * from "./CardsObjectivesRules.vue?vue&type=script&lang=js&"
import style0 from "./CardsObjectivesRules.vue?vue&type=style&index=0&id=78e69d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e69d50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
